import React from 'react';
//import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
//import nprogress from 'nprogress'
//import 'nprogress/nprogress.css'
import ErrorBoundary from './ErrorBoundary';
import renderMergedProps from '../utilities/renderMergedProps';
import omit from 'omit.js';

const propTypes = {};

const defaultProps = {};

//nprogress.configure({ showSpinner: false });

class PrivateRoute extends React.Component {
    // componentWillMount () {
    //     //nprogress.start()
    // }
    // componentDidMount () {
    //     //nprogress.done()
    // }
    render() {
        const rest = omit(this.props, ['component']);
        //console.log(`this.props.component:`, this.props.component)
        return (
            //<Route {...this.props} />
            <Route {...rest} render={props => (
				this.props.isAuthenticated ? (
					<ErrorBoundary>
					{ renderMergedProps(this.props.component, props, rest) }
					</ErrorBoundary>
				) : (
					<Redirect to={{
					    pathname: '/login',
					    state: { from: props.location }
					}}/>
				)
			)}/>
        );
    }
}

 PrivateRoute.propTypes = propTypes;
 PrivateRoute.defaultProps = defaultProps;

 export default PrivateRoute;